import type { ReactNode } from 'react';

export const ScreenOnly: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="screen-only">{children}</div>;
};
